module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    attrs: {
      "id": "FooterSite"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mainFooterContainer"
    }
  }, [_c('section', [_c('div', {
    staticClass: "topicoFooterContainer"
  }, [_c('h1', [_vm._v("Dúvidas?")]), _vm._v(" "), _c('ul', {
    staticClass: "ulFooter"
  }, [_c('li', [_c('router-link', {
    staticClass: "scrollup",
    attrs: {
      "to": {
        name: 'FAQ'
      }
    }
  }, [_vm._v("\n              FAQ (Perguntas Frequentes)\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "scrollup",
    attrs: {
      "to": {
        name: 'guide'
      }
    }
  }, [_vm._v("\n              Guia de Instalação do TAG\n            ")])], 1), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "topicoFooterContainer"
  }, [_c('h1', [_vm._v("Minha Conta")]), _vm._v(" "), _c('ul', {
    staticClass: "ulFooter"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'plans'
      }
    }
  }, [_vm._v(" Planos ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'requests'
      },
      "tag": "a"
    }
  }, [_vm._v("\n              Pedidos\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'tag-activate'
      },
      "tag": "a"
    }
  }, [_vm._v("\n              Ativar TAG\n            ")])], 1)])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "container-certificados"
  }, [(
    (_vm.selos[0] && _vm.selos[0].svg) ||
    (_vm.selos[1] && _vm.selos[1].svg) ||
    (_vm.selos[2] && _vm.selos[2].svg)
  ) ? _c('div', {
    staticClass: "wrapper-certificado"
  }, [_c('p', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("Certificações ISO")]), _vm._v(" "), _c('div', {
    staticClass: "certificados"
  }, [(_vm.selos[0] && _vm.selos[0].svg) ? _c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.selos[0].svg)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.selos[1] && _vm.selos[1].svg) ? _c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.selos[1].svg)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.selos[2] && _vm.selos[2].svg) ? _c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.selos[2].svg)
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.selos[3] && _vm.selos[3].svg) ? _c('div', {
    staticClass: "wrapper-certificado"
  }, [_c('p', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("Selo MESC")]), _vm._v(" "), _c('div', {
    staticClass: "certificados",
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.selos[3].svg)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.selos[4] && _vm.selos[4].svg) ? _c('div', {
    staticClass: "wrapper-certificado"
  }, [_c('p', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("Reclame Aqui")]), _vm._v(" "), _c('div', {
    staticClass: "certificados"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.selos[4].svg)
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _vm._m(7)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "suporteContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "IconeCentralContainer"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/svg/Helpdesk.svg")
    }
  }), _vm._v(" "), _c('h1', [_vm._v("CENTRAL DE RELACIONAMENTO")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "numeroFooterContainer"
    }
  }, [_c('h1', [_vm._v("\n        Capitais e regiões metropolitanas\n        "), _c('span', {
    staticClass: "numeroFooter"
  }, [_vm._v("4000 2901")]), _vm._v(" ou\n        "), _c('span', {
    staticClass: "numeroFooter"
  }, [_vm._v("0800 777 1022")]), _vm._v(" demais localidades\n      ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "emailFooterContainer"
    }
  }, [_c('h1', [_vm._v("\n        E-mail:\n        "), _c('span', {
    staticClass: "numeroFooter"
  }, [_c('a', {
    attrs: {
      "href": "mailto:relacionamento@movemais.com"
    }
  }, [_vm._v("relacionamento@movemais.com")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/tabela-de-tarifas-movemais",
      "target": "_blank"
    }
  }, [_vm._v("\n              Tarifas Move Mais\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topicoFooterContainer"
  }, [_c('h1', [_vm._v("Políticas")]), _vm._v(" "), _c('ul', {
    staticClass: "ulFooter"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/termos-e-condicoes-gerais-movemais",
      "target": "_blank",
      "title": "Termos e Condições"
    }
  }, [_vm._v("\n              Termos e Condições\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/aviso-de-privacidade-movemais",
      "target": "_blank"
    }
  }, [_vm._v("\n              Aviso de Privacidade\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/politica-de-cookies-movemais",
      "target": "_blank"
    }
  }, [_vm._v("\n              Política de Cookies\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/politica-de-reembolso-movemais",
      "target": "_blank"
    }
  }, [_vm._v("\n              Política de Reembolso\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/politica-da-qualidade-movemais",
      "target": "_blank"
    }
  }, [_vm._v("\n              Política da Qualidade\n            ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topicoFooterContainer"
  }, [_c('h1', [_vm._v("Compliance")]), _vm._v(" "), _c('ul', {
    staticClass: "ulFooter"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/codigo-de-conduta-movemais",
      "target": "_blank"
    }
  }, [_vm._v("\n              Código de Conduta\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.contatoseguro.com.br/movemais",
      "target": "_blank"
    }
  }, [_vm._v("\n              Canal de Ética\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/requisitos-pre-aprovacao-provedores-externos-movemais",
      "target": "_blank"
    }
  }, [_vm._v("\n              Requisitos Fornecedores\n            ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topicoFooterContainer"
  }, [_c('h1', [_vm._v("Formas de Pagamento")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "bandeirasContainer"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/svg/CardCartaoMastercard.svg")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/img/svg/CardCartaoVisa.svg")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/img/svg/CardCartaoElo.svg")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/img/svg/CardPix.svg")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "iconesFooter"
  }, [_c('p', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("Consumidor")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "consumidorContainer"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://consumidor.gov.br",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/svg/consumidorgov.svg"),
      "id": "consumidor"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "iconesFooter"
  }, [_c('p', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("Certificado")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "certificadoContainer"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/svg/sectigo-siteseal@3x.png"),
      "id": "certificado"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "iconesContainer"
    }
  }, [_c('div', {
    staticClass: "iconesFooter"
  }, [_c('h1', [_vm._v("Baixe nosso App")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://apps.apple.com/br/app/move-mais-ped%C3%A1gio-free-flow/id6747896915",
      "target": "_blank",
      "id": "appStoreContainer"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/svg/AppStore.svg")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.movemais.morfeu",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/svg/GooglePlay.svg")
    }
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "redesContainer"
    }
  }, [_c('h1', [_vm._v("Acompanhe-nos")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "redesSociaisContainer"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/MoveMais/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "iconesRedes",
    attrs: {
      "src": require("../assets/img/svg/facebook.svg")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/movemais/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "iconesRedes",
    attrs: {
      "src": require("../assets/img/svg/Instagram.svg")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/move-mais/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "iconesRedes",
    attrs: {
      "src": require("../assets/img/svg/linkedin.svg")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/user/movemais",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "iconesRedes",
    attrs: {
      "src": require("../assets/img/svg/youtube.svg")
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footerCNPJ"
    }
  }, [_c('div', [_c('h1', [_vm._v("\n        Move Mais Meios de Pagamento Ltda - CNPJ: 15.266.912/0001-87 -\n        Inscrição Estadual: 181.239.134.110\n      ")]), _vm._v(" "), _c('h1', [_vm._v("\n        Endereço: Avenida Rodrigo Fernando Grillo, 207, Edifício Victoria\n        Business, 20º andar - Araraquara, SP, Brasil - 14801-534\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-411485fe!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/app-footer.vue
// module id = 2109
// module chunks = 1